import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// TODO: Fixed this scuffed localization shit to use namespaces properly
import arTranslation from './locales/ar.min.json';
import enTranslation from './locales/en.min.json';
import heTranslation from './locales/he.min.json';
import hrTranslation from './locales/hr.min.json';

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: 'en',
    interpolation: {
      // not needed for react as it escapes by default
      escapeValue: false,
    },
    resources: {
      ar: {
        translation: arTranslation,
      },
      en: {
        translation: enTranslation,
      },
      he: {
        translation: heTranslation,
      },
      hr: {
        translation: hrTranslation
      }
    }
  });

export default i18n;